import "./style/settings.css";
import React, { useReducer, useState } from "react";
import { useForm } from "react-hook-form";
import { Outlet } from "react-router-dom";
import SettingsHeader from "./Settings/Header";
import LicenseNotice from "./common/LicenseNotice";
import { __ } from "@wordpress/i18n";
import SettingsTabs from "./Settings/Tabs";
import { ajaxCall } from "./Helpers/AjaxHelper";
import SaveSettingsButton from "./Settings/SaveSettingsButton";
import SettingsFooter from "./Settings/SettingsFooter";
import StickyWidget from "./StickyWidget";
import { SourcesRedirectPopup } from "./Settings/Sources/SourceRedirectPopup";
import SettingPage from "./common/SettingPage";

export const SettingsContext = React.createContext({});

const initialState = {
  sources: window.sby_settings.settings.connected_accounts,
  notifications: [],
};

const reducer = (state, action) => {
  const draft = { ...state };
  switch (action.type) {
    case "delete_source": {
      delete draft.sources[action.payload];
      return { ...draft };
    }
    case "add_notification": {
      draft.notifications.push(action.payload);
      return draft;
    }
    case "set_notifications":
      draft.notifications = action.payload;
      return draft;
    default:
      return state;
  }
};

const Settings = () => {
  const { register, handleSubmit, watch } = useForm();
  const [state, dispatch] = useReducer(reducer, initialState);

  const [formSubmitting, setFormSubmitting] = useState(false);
  const [requestSuccess, setRequestSuccess] = useState(false);
  const [showSourcesPopup, setShowSourcesPopup] = useState(false);
  return (
    <SettingsContext.Provider
      value={{
        register,
        settings: { ...window.sby_settings.settings },
        single_video_settings: { ...window.sby_settings.single_video_settings },
        sbySettings: { ...window.sby_settings },
        sbyIsPro: window.sby_settings.sbyIsPro,
        formSubmitting,
        requestSuccess,
        showSourcesPopup,
        setShowSourcesPopup,
        state,
        dispatch,
        watch,
      }}
    >
      <>
        <form
          onSubmit={handleSubmit((data) => {
            setFormSubmitting(true);
            setRequestSuccess(false);

            if (window.sby_settings && window.sby_settings.settings) {
              window.sby_settings.settings = {
                ...window.sby_settings.settings,
                ...data,
              };
            }

            ajaxCall("sby_update_settings", data)
              .then(() => {
                setRequestSuccess(true);
                setTimeout(() => {
                  setRequestSuccess(false);
                }, 3000);
              })
              .finally(() => {
                setFormSubmitting(false);
              });
          })}
        >
          {window.sby_settings.shouldShowPostGracePeriodNotice ? (
            <LicenseNotice />
          ) : null}
          <SettingsHeader title={__("Settings", "feeds-for-youtube")} />
          <SettingPage
            headerClassName="sby-settings-header"
            title={__("Settings", "feeds-for-youtube")}
          >
            <div className="sb-tabs-container" id="sb-tabs-container">
              <SettingsTabs />
              <div className="sb-tab-content slide-fade-enter-active">
                <Outlet />
                <div className="sby-save-button pb-4">
                  <SaveSettingsButton />
                </div>
                {window.sby_settings.sbyIsPro ? (
                  ""
                ) : (
                  <div className="sby-settings-footer">
                    <SettingsFooter />
                  </div>
                )}
              </div>
            </div>
          </SettingPage>
        </form>
        <StickyWidget />
        {showSourcesPopup && <SourcesRedirectPopup />}
      </>
    </SettingsContext.Provider>
  );
};

export default Settings;
